import ErrorPage from './Error';
import renderPage from '../config/renderPage';

const el = document.getElementById('main');

renderPage({
    el,
    initialState: window.__REDUX_STATE__,
    component: ErrorPage,
    theme: window.__THEME__,
});
